import { TopDestinationsGroup } from 'core/type/ActivitiesTopDestinations.types';
import { getMocks } from 'core/window/windowService';
import { measureTopDestinationApiResponse } from 'store/api/measurements/homePageMeasurements';
import { BootstrapConfig } from 'core/type/BootstrapConfig.types';
import { TopDestinationsResponse } from 'store/api/api.types';
import { isQueryLoading } from 'store/api/apiUtils';

const EmptyTopDestinationsGroup: TopDestinationsGroup = { topDestinations: [], topDomesticDestinations: [], domesticCountry: undefined };

export const getTopDestinations = (response: TopDestinationsResponse, pageTypeId: number, config: BootstrapConfig): TopDestinationsGroup => {
    if (config.isMockData) {
        const mocks = getMocks();
        return mocks.topDestinationsGroup;
    }
    if (!isQueryLoading(response)) {
        measureTopDestinationApiResponse(response, pageTypeId, config);
    }
    if (response.isSuccess) {
        const data = response.data || EmptyTopDestinationsGroup;
        const topDestinations = data.topDestinations || [];
        return {
            topDestinations,
            topDomesticDestinations: data.topDomesticDestinations && data.topDomesticDestinations.length > 0 ? data.topDomesticDestinations : topDestinations,
            domesticCountry: data.domesticCountry,
        };
    }
    return EmptyTopDestinationsGroup;
};
